export default __webpack_public_path__ + "static/media/EconomicsSpendingSaving_08.76ec5eae.png";